import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#6a4c93',
    },
    secondary: {
      main: '#75934c',
    },
  },
});

export default theme;
